import { TElevation } from '@unfold/theme';
export const DEFAULT_ELEVATION: TElevation = 'e150';
